// extracted by mini-css-extract-plugin
export default {"container":"Cw-z","heading":"Dw-z","text":"Ew-z","info":"Fw-z","link":"Gw-z","fullMaxWidth":"Hw-z"};